// Wrappers para los endpoints /api/bookings/*.

import { apiFetch } from './api';

export type BookingType = 'one' | 'gr';
export type BookingStatus = 'scheduled' | 'cancelled' | 'completed' | 'no_show';

export interface BookingListItem {
  id: number;
  type: BookingType;
  teacher_id: number;
  teacher_name: string;
  cohort_id: number | null;
  scheduled_at: string;
  duration_min: number;
  max_students: number;
  status: BookingStatus;
  created_by: number;
  created_by_role: 'student' | 'teacher' | 'admin';
  cancelled_at: string | null;
  notes: string | null;
  active_students: number;
}

export interface BookingsResponse {
  status: 'ok';
  from: string;
  to: string;
  items: BookingListItem[];
}

export async function listMyBookings(year?: number, month?: number, includeCancelled = false): Promise<BookingsResponse> {
  const q = new URLSearchParams();
  if (year !== undefined) q.set('year', String(year));
  if (month !== undefined) q.set('month', String(month));
  if (includeCancelled) q.set('includeCancelled', 'true');
  const qs = q.toString();
  return apiFetch<BookingsResponse>(`/bookings/me${qs ? `?${qs}` : ''}`);
}

export async function listGroupsAvailable(year?: number, month?: number): Promise<BookingsResponse> {
  const q = new URLSearchParams();
  if (year !== undefined) q.set('year', String(year));
  if (month !== undefined) q.set('month', String(month));
  const qs = q.toString();
  return apiFetch<BookingsResponse>(`/bookings/me/groups-available${qs ? `?${qs}` : ''}`);
}

export async function createOneBooking(scheduledAtLocal: string, notes?: string): Promise<{ id: number }> {
  return apiFetch<{ status: 'ok'; id: number }>('/bookings/one', {
    method: 'POST',
    body: JSON.stringify({ scheduled_at: scheduledAtLocal, ...(notes ? { notes } : {}) }),
  }).then((r) => ({ id: r.id }));
}

export async function createGroupBooking(input: {
  teacher_id: number;
  scheduled_at: string;
  max_students: number;
  duration_min?: number;
  cohort_id?: number | null;
  notes?: string;
}): Promise<{ id: number }> {
  return apiFetch<{ status: 'ok'; id: number }>('/bookings/gr', {
    method: 'POST',
    body: JSON.stringify(input),
  }).then((r) => ({ id: r.id }));
}

export async function listTeacherBookings(year?: number, month?: number): Promise<BookingsResponse> {
  const q = new URLSearchParams();
  if (year !== undefined) q.set('year', String(year));
  if (month !== undefined) q.set('month', String(month));
  const qs = q.toString();
  return apiFetch<BookingsResponse>(`/bookings/teacher/me${qs ? `?${qs}` : ''}`);
}

export interface BookingDetailStudent {
  booking_id: number;
  student_id: number;
  joined_at: string;
  student_display_name?: string;
  student_email?: string;
}

export async function getBookingDetail(id: number): Promise<{ status: 'ok'; booking: BookingListItem; students: BookingDetailStudent[] }> {
  return apiFetch(`/bookings/${id}`);
}

export async function joinGroupBooking(bookingId: number): Promise<void> {
  await apiFetch(`/bookings/${bookingId}/join`, { method: 'POST' });
}

export async function leaveGroupBooking(bookingId: number): Promise<void> {
  await apiFetch(`/bookings/${bookingId}/leave`, { method: 'DELETE' });
}

export async function cancelBooking(bookingId: number, reason?: string): Promise<void> {
  await apiFetch(`/bookings/${bookingId}`, {
    method: 'DELETE',
    body: JSON.stringify(reason ? { reason } : {}),
  });
}
